// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"1e0c3679","460":"987edf50","531":"ac2f4dbc","532":"6b80be4d","547":"dbf842d2","742":"427e0648","884":"0264e686","917":"4d3592e4"}[chunkId] + ".chunk.js";
};